import { useMemo } from 'react'
import { useDroppable } from '@dnd-kit/core'
import type { CueDropzone } from '../model/dnd'
import { DroppableId } from '../model/dnd'
import type { DroppableCue } from '../model/types'
import { draggingCueAtom } from '../store/dnd.store'
import { useAtomValue } from 'jotai'

type UseDroppableCueParams = {
  cue?: DroppableCue
  dropzoneType: CueDropzone
}

export const useDroppableCue = ({
  cue,
  dropzoneType,
}: UseDroppableCueParams) => {
  const draggingCue = useAtomValue(draggingCueAtom)

  const isDropAreaDisabled = useMemo(() => {
    // If cues are already inside a group
    if (cue?.parentId || draggingCue?.parentId) return true
    // If dragging a group
    if (Array.isArray(draggingCue?.children)) return true

    // If cue is dropped on itself
    return draggingCue?.id === cue?.id
  }, [
    cue?.id,
    cue?.parentId,
    draggingCue?.children,
    draggingCue?.id,
    draggingCue?.parentId,
  ])

  return useDroppable({
    // Can be a race condition when cue is optimistically removed from DOM
    id: cue ? DroppableId[dropzoneType](cue.id) : 'ALREADY_REMOVED_CUE',
    disabled: isDropAreaDisabled,
    data: {
      cue,
    },
  })
}
